import HomeIcon from '@mui/icons-material/Home';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DataObjectIcon from '@mui/icons-material/DataObject';
import * as React from 'react';
import { paths } from './routes';

interface AppNavigationItem {
  title: string;
  path: string;
  icon: any;
  items?: AppNavigationItem[];
}
export const navigation: AppNavigationItem[] = [
  { title: 'navigation.item-1', path: '/', icon: <HomeIcon /> },
  { title: 'navigation.item-2', path: paths.ASSETS_LIST, icon: <DynamicFormIcon /> },
  {
    title: 'navigation.item-3',
    path: paths.MASTER_DATA_REDIRECT,
    icon: <DataObjectIcon />,
  },
  { title: 'navigation.item-4', path: paths.APP_INFO, icon: <InfoOutlinedIcon /> },
];
